import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { QuestionsService } from '../../../services/Audit/questions-table.service';
import { AuditOverviewService } from 'src/app/services/Audit/audit-overview.service';
import { QuestionTableConstant } from './question-table.constant';
import { AuditSharedService } from 'src/app/services/Audit/audit-shared.service';
import { StageReviewDetail } from '../project-overview/models/stage-review.model';
import { ProjectDetailConstant } from '../project-overview/project-detail.constant';
import { CategoryReviewerModel } from '../project-overview/models/category-reviewer.model';
import { ToastrService } from 'ngx-toastr';
import { QuestionResponseModel } from './question-response.model';

@Component({
  selector: 'app-questions-table',
  templateUrl: './questions-table.component.html',
  styleUrls: ['./questions-table.component.css']
})
export class QuestionsTableComponent implements OnInit {
  
  private _CONSTANTS:QuestionTableConstant;
  stage: string = '';
  auditId:number = 0;
  ratingId:number = 0;
  projectDetails:any = [];
  tableData:any = [];
  questionTableResponseData: Array<QuestionResponseModel> = [];
  auditCategories:any = [];
  responseDropDownOptions:any = [];
  categoryInfo:any;
  categoryId:number = 0;  
  currentDate = new Date(Date.now());
  navigateToProjectOverview:string = '/';   
  reviewComment:string = '';
  reviewRating:number = 0;
  reviewerName: string = 'NA';
  stageReviewDetails:StageReviewDetail;
  questionSaveErrorMessage:string = '';
  reviewSaveErrorMessage:string = '';
  isError:boolean = true;
  isCommentDisabled: boolean = false;
  hideSubmitButton: boolean = false;
  isPopupOpen = false; 
  questionText = ''; 
  selectedSubCategory: string | null = null; 
 
  private _CONSTATNTS:ProjectDetailConstant;
  startDate: number;
  x={one:'1'}
  

  constructor(private route: ActivatedRoute, private router: Router
                                           , private questionService: QuestionsService
                                           , private auditOverviewService: AuditOverviewService
                                           , private auditSharedService: AuditSharedService
                                           , public toasterService: ToastrService){
                                             this._CONSTANTS = new QuestionTableConstant();
                                           }
  
  ngOnInit(): void {
    this.getAuditId();
    this.route.params.subscribe(params => {
      const rawId = params['id'];
      const pascalCaseId = this.toPascalCase(rawId);
      if (rawId !== pascalCaseId) {
        this.router.navigate(['Home/Audit/Audit Overview', pascalCaseId]);
      } else {
        this.stage = pascalCaseId;
      }
    });

    //Get Initial Page Data
    this.getQeustionsTableData();
    this.getResponseDropdownItems();
    this.getStageReviewDetails();
  }
  toPascalCase(str: string): string {
    return str.replace(/\w+/g, 
        (w) => w[0].toUpperCase() + w.slice(1).toLowerCase());
}

  ngOnDestroy() {
    this.auditId_DestroyState();
  }

  getAuditId = () => {
    //Retrieve auditId which is set by Audit Overview Page
    this.auditSharedService.getAuditId().subscribe((_auditId: number) => this.auditId = _auditId);
    this.auditId_MaintainState();
  }
  openPopup(): void {
    this.isPopupOpen = true;
  }

  closePopup(): void {
    this.isPopupOpen = false;
  }
  onSubmit(): void {
    const formData = {
      question: this.questionText,
      subCategory: this.selectedSubCategory,
    };
    this.closePopup(); 
  }

  auditId_MaintainState = () => {
    if(this.auditId > 0){
      localStorage.setItem('AuditId',this.auditId?.toString());
    }

    if(this.auditId < 1)
    {
      const id = parseInt(localStorage.getItem('AuditId'));
      this.auditId =  (!isNaN(id)) ? id : this.auditId;
    }
  }

  auditId_DestroyState = () => {
    localStorage.removeItem('AuditId');
  }

  getResponseDropdownItems(){
    //Get Response DropDownList Options
    this.questionService.getAuditResponseDropDown().subscribe(
      (responseData) => {
        this.responseDropDownOptions = responseData;
      },
      (error) => {
        console.log(`${this._CONSTANTS.GET_RESPONSE_DROPDOWN_API_ERROR}: `,error);
      }
    );
  }

  getQeustionsTableData(){
    //Get Categories details to find CategoryId then questions by category
    this.auditOverviewService.getCategoryDropDown().subscribe(
      (responseData) => {   
          this.auditCategories = responseData;
          this.categoryInfo = this.auditCategories.filter(x => x.description?.toLocaleLowerCase() == this.stage.toLocaleLowerCase())[0]; //Keep into global
          this.categoryId = this.categoryInfo.id; 
      },
      (error) => {
        console.log(`${this._CONSTANTS.GET_CATEGORY_DROPDOWN_API_ERROR}: `, error);   
      },
      (complee:void) => {
        //Get questions by category
        (this.categoryId > 0) && this.questionService.getQuestions(this.categoryId).subscribe(
          (responseData) => {
            this.tableData = responseData;
            //Add uesr input fields into each question object
            const defaultSelectedValue = 0;
            this.tableData = this.tableData.map((data) => ({...data, comment: ''
                                                                  , auditorComment:''
                                                                  , selectedResponseOption:defaultSelectedValue
                                                                  , supportingMaterial: defaultSelectedValue}));
          },
          (error) => {
            console.log(`${this._CONSTANTS.GET_QUESTION_TABLE_DATA_API_ERROR}:`, error);
          },
          (complete:void) => {
            this.getQuestionTableResponse(); //It is dependent on categoryId and auditId
          });

          if(this.categoryId > 0 && this.auditId){
            this.getCategoryReviewer(this.auditId, this.categoryId);
          }
      }    
    );
  }

  getCategoryReviewer(auditId:number, categoryId:number){
    this.reviewerName  = '';
    this.auditOverviewService.getCategoryReviewerDetail(this.auditId,this.categoryId).subscribe(
      (responseData: CategoryReviewerModel) => {
        if(responseData){
          this.reviewerName = responseData.reviewerName?.toString();
        }
      },
      (error) => {
        console.log(this._CONSTANTS.GET_CATEGORY_REVIEWER_API_ERROR,error); 
      }
    );
  }

  getStageReviewDetails(){
    this.auditOverviewService.getStageReviewDetails(this.auditId).subscribe(
      (response: Array<StageReviewDetail>) => {  
        this.stageReviewDetails = response.filter(stage => stage.categoryName.toLocaleLowerCase() == this.stage?.toLowerCase())[0];                             
        if(this.stageReviewDetails)
        {
          this.reviewComment = (this.stageReviewDetails) ? this.stageReviewDetails.comment : '';
          this.reviewRating = (this.stageReviewDetails) ? this.stageReviewDetails.rating : 0;
          if(this.reviewComment){
            this.disableCommentsSection(this.reviewComment)
          }       
          const category_name = this.stage.toLocaleLowerCase();
          const categoryRating_id = ((category_name == 'middleware') ? 1 : (category_name == 'database')? 2 : (category_name == 'security') ? 3 : -1);
          this.ratingId = categoryRating_id ;
          this.hideSubmitButton = this.reviewRating > 0 && this.reviewComment.trim() !== '';

        }        
      },
      (error) => { console.log(`${this._CONSTATNTS.GET_STAGES_REVIEW_DETAIL_API_ERROR}: `,error); }
    );    
  }

  getQuestionTableResponse()
  {
    this.questionService.getQuestionsResponse(this.auditId, this.categoryId).subscribe(
      (responseData:Array<QuestionResponseModel>) => {
        this.questionTableResponseData = responseData;        
      },
      (error) => {
        console.log(this._CONSTANTS.GET_QUESTION_RESPONSE_API_ERROR,error);
      },
      (complete: void) => {
        this.bindSavedQuestionResponseInUI();
      }
    );
  }

  bindSavedQuestionResponseInUI()
  {
    if(this.tableData?.length > 0 && this.questionTableResponseData?.length > 0){
      const questionCount = this.tableData.length;
      const responseCount = this.questionTableResponseData.length;

      if(questionCount > responseCount)
      {
        this.toasterService.error('Question and Question response count is different.');
        return;
      }

      for (let i = 0; i < this.tableData?.length; i++) {
        const responseText = this.questionTableResponseData[i]?.response;
        const savedResponseId = this.responseDropDownOptions.filter(x => x.description?.toLocaleLowerCase() == responseText?.toLocaleLowerCase())[0].id
        this.tableData[i].selectedResponseOption = savedResponseId;
        let isSupportingMaterialVerified: any = this.questionTableResponseData[i].isSupportingMaterialVerified;

        if (typeof isSupportingMaterialVerified === 'string') {
          isSupportingMaterialVerified = isSupportingMaterialVerified.toLowerCase() === "true";
        } else if (isSupportingMaterialVerified === null || isSupportingMaterialVerified === undefined) {
          isSupportingMaterialVerified = false; 
        }
        this.tableData[i].supportingMaterial = isSupportingMaterialVerified;       
        this.tableData[i].comment = this.questionTableResponseData[i].observationExceptionsReasons;
        this.tableData[i].auditorComment = this.questionTableResponseData[i].auditorRecommedation;            
      }
    }
  }

  resetQuestionTable(){
    try {
      if(this.tableData?.length > 0)
      {
        for (let i = 0; i < this.tableData?.length; i++) {
          this.tableData[i].selectedResponseOption = 0;
          this.tableData[i].supportingMaterial = 0;
          this.tableData[i].comment = '';
          this.tableData[i].auditorComment = '';
        }
      }
    } 
    catch (error) {      
    }    
  }

  sendNotification(){
    this.toasterService.info("Currently, this feature is not available!");
  }

  createRange(count:number){
    return Array(count).fill(0).map((x,i) => i+1);
  }
  
  getQuestionFormValidationError(requestData:Array<any>)
  {
    let validationErrors: string = "";
    if(requestData.filter(x =>  x.responseId == -1)?.length > 0)
    {
      validationErrors = 'Please select a valid response';
    }
    
    if(requestData.filter(x =>  x.observationExceptionsReasons?.length > 0)?.length < 1)
    {
      validationErrors += `${validationErrors?.length > 0 ? ', ': ''}Please add comment`;
    }
    return validationErrors;    
  }
  saveQuestionTableResponseData(){
    let requestData = [];
    const currentUserId = parseInt(localStorage.getItem('Id'));
    //Build request Data 
    this.tableData.forEach(o => {
      let data = {
                  id:0, //new response
                  auditId : this.auditId,                   
                  questionId : o.questionId,   
                  responseId : parseInt(o.selectedResponseOption),               
                  isSupportingMaterialVerified: o.supportingMaterial,
                  observationExceptionsReasons : o.comment,
                  auditorRecommedation : o.auditorComment,                  
                  isActive : this.categoryInfo.isActive, //need to confirm
                  createdBy : currentUserId,
                  createdOn : this.currentDate.toISOString(),
                  modifyBy : currentUserId,
                  modifyOn : this.currentDate.toISOString()
      };
      requestData.push(data);
    });
    let validationError  = this.getQuestionFormValidationError(requestData);
    if(validationError?.length > 0){
       this.toasterService.error(validationError);
       validationError = "";
       return;
    }
    
    this.questionService.saveQuestionsResponse(requestData).subscribe(
      (response) => {
        this.toasterService.success(this._CONSTANTS.QEUSTION_RESPONSE_SUBMIT_SUCCESS);     
        this.questionSaveErrorMessage = this._CONSTANTS.QEUSTION_RESPONSE_SUBMIT_SUCCESS;
      },
      (error) => {   
        this.questionSaveErrorMessage = this._CONSTANTS.QEUSTION_RESPONSE_SUBMIT_ERROR;
        this.toasterService.error(this.questionSaveErrorMessage); 
      });

  }

  ratingChangeHandler(event): void {
      this.reviewRating = parseInt(event.target.value);
  }

  disableCommentsSection(comments: string) {
    this.reviewComment = comments;
    this.isCommentDisabled = true;
  }

  submitCategoryReview(){
    if(this.ratingId > 0){
      this.toasterService.info("Review already submitted earlier");
      return;
    }
    
    //Build request data
    const currentUserId = parseInt(localStorage.getItem('Id'));
    let requestData = {
          id : this.ratingId, //new review
          auditId : this.auditId,
          categoryId : this.categoryId,
          isActive : (this.categoryInfo)? this.categoryInfo.isActive : false,
          rating : this.reviewRating,
          comments : this.reviewComment,
          categoryReviewerId : currentUserId, 
          createdBy : currentUserId,
          createdOn : this.currentDate.toISOString(),
          modifyBy : currentUserId,
          modifyOn : this.currentDate.toISOString(),
    };
  
    if(requestData?.rating < 1)
    {
      this.toasterService.error('Please provide a rating.');
      return;
    }
    if (!requestData.comments || requestData.comments.trim() === '') {
      this.toasterService.error('Please add comments.');
      return;
    } else {
      this.disableCommentsSection(requestData.comments);
    }
    this.questionService.saveCategoryReview(requestData).subscribe(
      (response) => { 
        this.isError = false;
        this.toasterService.success(this._CONSTANTS.CATEGORY_REVIEW_SUBMIT_SUCCESS);
        this.auditSharedService.setAuditId(this.auditId); // Make auditId available for project-overview page
        this.questionService.setCreatedOn(this.auditId, this.categoryId, requestData.createdOn); // Store createdOn date        
        this.auditOverviewService.getCategoryReviewerDetail(this.auditId, this.categoryId);       
        setTimeout(() => {
          this.router.navigate(['Home/Audit/Audit Overview', { auditId: this.auditId, categoryId: this.categoryId }]);
        }, 0);
      },
      (error) => { 
        this.isError = true;
        this.reviewSaveErrorMessage = this._CONSTANTS.CATEGORY_REVIEW_SUBMIT_ERROR;
        this.toasterService.error(this.reviewSaveErrorMessage);
      }
    ); 
    
  }
  
  navigateBackToProjectOverview() {
    this.auditSharedService.setAuditId(this.auditId);
    this.router.navigate(['Home/Audit/Audit Overview']);
  }
  

}